import '../static/CardGrid.css';
import React__default, { lazy, forwardRef, useMemo, Suspense } from "react";
import clsx from "clsx";
import { b as SectionHeader, c as SectionHeaderActions } from "./SectionHeader.VCo9GnTI.mjs";
import { b as ContentGrid } from "./ContentGrid.Bk7uBKEc.mjs";
import { a as SectionWrap } from "./SectionWrap.DExzuSui.mjs";
import { C as Col } from "./Col.COJSUXXS.mjs";
import { b as breakpoints } from "./sword.DtiKVPhx.mjs";
import { u as useBetterMediaQuery } from "./useBetterMediaQuery.xTM_WrtF.mjs";
const gradient = `_gradient_9abba16`;
const centerGradient = `_centerGradient_9b7ee0e`;
const vertical = `_vertical_d573559`;
const horizontal = `_horizontal_81bb281`;
const customHeader = `_customHeader_4489612`;
const hiddenActions = `_hiddenActions_96071a6`;
const limitWidth = `_limitWidth_8117453`;
const styles = { gradient, centerGradient, vertical, horizontal, customHeader, hiddenActions, limitWidth };
const DefaultCard = lazy(
  () => import("./DefaultCard.DNlsEQg9.mjs").then((module) => ({
    default: module.DefaultCard
  }))
);
const IconCard = lazy(
  () => import("./IconCard.CqJlz4ae.mjs").then((module) => ({
    default: module.IconCard
  }))
);
const SolutionCard = lazy(
  () => import("./SolutionCard.CVVBNM9Z.mjs").then((module) => ({
    default: module.SolutionCard
  }))
);
const StatCard = lazy(
  () => import("./StatCard.CLPZ8dPe.mjs").then((module) => ({
    default: module.StatCard
  }))
);
const CARD_GRID_TYPES = ["default", "icon", "solution", "stat"];
const CARD_GRID_LAYOUT = ["horizontal", "vertical"];
const CardGridItem = ({
  card,
  cardType
}) => {
  switch (cardType) {
    case "icon":
      return /* @__PURE__ */ React__default.createElement(IconCard, { ...card });
    case "solution":
      return /* @__PURE__ */ React__default.createElement(SolutionCard, { ...card });
    case "stat":
      return /* @__PURE__ */ React__default.createElement(StatCard, { ...card });
    default:
      return /* @__PURE__ */ React__default.createElement(DefaultCard, { ...card });
  }
};
const layoutColumnValidation = (layout, columns) => {
  return layout === CARD_GRID_LAYOUT[0] ? Math.min(Math.max(columns, 1), 2) : Math.min(Math.max(columns, 2), 4);
};
const CardGridInner = ({
  backgroundGradient = true,
  cardList,
  cardType = "default",
  className,
  columnCount = 2,
  sectionHeader,
  layout = CARD_GRID_LAYOUT[1],
  buttonGroupPosition = "default",
  ...props
}, ref) => {
  const isDesktop = useBetterMediaQuery(`(min-width: ${breakpoints.minLg})`);
  const isHorizontal = useMemo(() => layout === CARD_GRID_LAYOUT[0], [layout]);
  const layoutColumns = useMemo(
    () => layoutColumnValidation(layout, Number(columnCount)),
    [layout, columnCount]
  );
  const bottomActions = useMemo(
    () => layout === CARD_GRID_LAYOUT[1] && buttonGroupPosition === "bottom" && (columnCount === 3 || columnCount === 4),
    [layout, columnCount, buttonGroupPosition]
  );
  if (!cardList || !cardList.length || cardList.length < 2) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(SectionWrap, { ...props, className, ref, "data-ui": "card-grid" }, sectionHeader && /* @__PURE__ */ React__default.createElement(Col, { sm: 12, md: 12, lg: isHorizontal ? 4 : 12 }, /* @__PURE__ */ React__default.createElement(
    SectionHeader,
    {
      className: clsx(styles[layout], styles.customHeader, {
        [styles.oneColumn]: isHorizontal && columnCount === 1,
        [styles.hiddenActions]: bottomActions
      }),
      "data-testid": "ui-card-grid-header",
      xAlign: isHorizontal && isDesktop ? "left" : "center",
      ...sectionHeader
    }
  )), /* @__PURE__ */ React__default.createElement(Col, { sm: 12, md: 12, lg: isHorizontal && sectionHeader ? 8 : 12 }, /* @__PURE__ */ React__default.createElement(
    ContentGrid,
    {
      xAlign: Number(layoutColumns) <= 2 && isDesktop ? "left" : "center",
      columnCount: layoutColumns,
      layout: columnCount === 2 ? "gap" : "default",
      className: clsx({
        [styles.limitWidth]: isHorizontal && columnCount === 1,
        [styles.gradient]: backgroundGradient,
        [styles.centerGradient]: isHorizontal && sectionHeader
      }),
      "data-testid": "ui-card-grid-content-grid"
    },
    cardList.map((card, index) => /* @__PURE__ */ React__default.createElement(Suspense, { key: index }, /* @__PURE__ */ React__default.createElement(CardGridItem, { card, cardType })))
  )), bottomActions && sectionHeader && sectionHeader.buttonGroup && /* @__PURE__ */ React__default.createElement(SectionHeaderActions, { buttonGroup: sectionHeader.buttonGroup }));
};
const CardGrid = forwardRef(CardGridInner);
export {
  CARD_GRID_TYPES as C,
  CARD_GRID_LAYOUT as a,
  CardGrid as b
};
//# sourceMappingURL=CardGrid.Dgn8_JfO.mjs.map
